<div class="main-container">
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      @if (SamparkEolDeviceAdd) {
        <span class="page-title">Add Sampark EOL Device</span>
      }
      @if (SamparkEolDeviceUpdate) {
        <span class="page-title">Update Sampark EOL Device</span>
      }
    </div>
  </div>

  <div class="component-container">
    <!-- Component Header Section -->
    <div class="component-header">
      <h6 class="component-title">Sampark EOL Device Details</h6>
    </div>

    <!-- Separator between Header and Body -->
    <div class="component-separator"></div>

    <!-- Component Body Section -->
    <div class="component-body">
      <form [formGroup]="samparkEolDeviceAddForm" novalidate>
        <div class="form-section">
          <!-- IMEI -->
          <div class="form-group">
            <label for="imei" class="form-label">IMEI</label>
            <mat-form-field class="form-field" appearance="outline">
              <mat-label>IMEI</mat-label>
              <input
                id="imei"
                placeholder="IMEI"
                formControlName="imei"
                matInput
                required
                type="text"
                [readonly]="SamparkEolDeviceUpdate"
              />
              @if (
                samparkEolDeviceAddForm.controls['imei'].touched &&
                samparkEolDeviceAddForm.controls['imei'].errors
                  ?.lengthCheckValidator
              ) {
                <mat-error>
                  <span>{{
                    samparkEolDeviceAddForm.controls['imei'].errors
                      ?.lengthCheckValidator
                  }}</span>
                </mat-error>
              }
            </mat-form-field>
          </div>

          <!-- VIN -->
          <div class="form-group">
            <label for="vinNo" class="form-label">VIN No.</label>
            <mat-form-field class="form-field" appearance="outline">
              <mat-label>VIN No.</mat-label>
              <input
                id="vinNo"
                placeholder="VIN No."
                formControlName="vinNo"
                matInput
                type="text"
                required
              />
              @if (
                samparkEolDeviceAddForm.controls['vinNo'].touched &&
                samparkEolDeviceAddForm.controls['vinNo'].errors
                  ?.lengthCheckValidator
              ) {
                <mat-error>
                  <span>{{
                    samparkEolDeviceAddForm.controls['vinNo'].errors
                      ?.lengthCheckValidator
                  }}</span>
                </mat-error>
              }
            </mat-form-field>
          </div>

          <!-- Location Name -->
          <div class="form-group">
            <label for="locationName" class="form-label">Location Name</label>
            <mat-form-field class="form-field" appearance="outline">
              <mat-label>Location Name</mat-label>
              <input
                id="locationName"
                placeholder="Location Name"
                formControlName="locationName"
                matInput
                type="text"
                readonly
              />
            </mat-form-field>
          </div>

          <!-- Account Id -->
          <div class="form-group">
            <label for="accountId" class="form-label">Account Id</label>
            <mat-form-field appearance="outline">
              <mat-label>Account Id</mat-label>
              <mat-select
                formControlName="accountId"
                required
                (selectionChange)="onAccountIdChange($event.value)"
              >
                @for (option of accountIdOptions; track option) {
                  <mat-option [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                }
              </mat-select>
              @if (
                samparkEolDeviceAddForm.controls['accountId'].touched &&
                samparkEolDeviceAddForm.controls['accountId'].errors
                  ?.requiredAndNoEmptySpaces
              ) {
                <mat-error>
                  <span>{{
                    samparkEolDeviceAddForm.controls['accountId'].errors
                      ?.requiredAndNoEmptySpaces
                  }}</span>
                </mat-error>
              }
            </mat-form-field>
          </div>

          <!-- Device Type Name -->
          <div class="form-group">
            <label for="deviceTypeName" class="form-label"
              >Device Type Name</label
            >
            <mat-form-field class="form-field" appearance="outline">
              <mat-label>Device Type Name</mat-label>
              <input
                id="deviceTypeName"
                placeholder="Device Type Name"
                formControlName="deviceTypeName"
                matInput
                type="text"
                required
                [readonly]="SamparkEolDeviceUpdate"
              />
            </mat-form-field>
          </div>

          <!-- Protocol Type Name -->
          <div class="form-group">
            <label for="protocolTypeName" class="form-label"
              >Protocol Type Name</label
            >
            <mat-form-field class="form-field" appearance="outline">
              <mat-label>Protocol Type Name</mat-label>
              <input
                id="protocolTypeName"
                placeholder="Protocol Type Name"
                formControlName="protocolTypeName"
                matInput
                type="text"
                readonly
              />
            </mat-form-field>
          </div>

          <!-- TCU Serial Number -->
          <div class="form-group">
            <label for="tcuSerialNumber" class="form-label"
              >TCU Serial Number</label
            >
            <mat-form-field class="form-field" appearance="outline">
              <mat-label>TCU Serial Number</mat-label>
              <input
                id="tcuSerialNumber"
                placeholder="TCU Serial Number"
                formControlName="tcuSerialNumber"
                matInput
                type="text"
              />
            </mat-form-field>
          </div>

          <!-- TCU Part Number -->
          <div class="form-group">
            <label for="tcuPartNumber" class="form-label"
              >TCU Part Number</label
            >
            <mat-form-field class="form-field" appearance="outline">
              <mat-label>TCU Part Number</mat-label>
              <input
                id="tcuPartNumber"
                placeholder="TCU Part Number"
                formControlName="tcuPartNumber"
                matInput
                type="text"
              />
            </mat-form-field>
          </div>

          <!-- Vehicle Type -->
          <div class="form-group">
            <label for="vehicleType" class="form-label">Vehicle Type</label>
            <mat-form-field class="form-field" appearance="outline">
              <mat-label>Vehicle Type</mat-label>
              <input
                id="vehicleType"
                placeholder="Vehicle Type"
                formControlName="vehicleType"
                matInput
                type="text"
                readonly
              />
            </mat-form-field>
          </div>

          <!-- Transmission Type -->
          <div class="form-group">
            <label for="transmissionType" class="form-label"
              >Transmission Type</label
            >
            <mat-form-field class="form-field" appearance="outline">
              <mat-label>Transmission Type</mat-label>
              <input
                id="transmissionType"
                placeholder="Transmission Type"
                formControlName="transmissionType"
                matInput
                type="text"
                readonly
              />
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
    <div class="component-separator"></div>
    <!-- Component Footer Section -->
    <div class="component-footer">
      <div class="button-group">
        @if (SamparkEolDeviceAdd) {
          <button
            class="submit-button"
            (click)="validateFormSave()"
            [disabled]="this.samparkEolDeviceAddForm.invalid"
          >
            Submit <mat-icon class="btn-icon">check_circle</mat-icon>
          </button>
        }
        @if (SamparkEolDeviceUpdate) {
          <button class="edit-button" (click)="validateFormUpdate()">
            Update <mat-icon class="btn-icon">edit</mat-icon>
          </button>
        }
      </div>
    </div>
  </div>
</div>
